import { useModal } from "shared/composables";

export const useModalStore = defineStore("modal", () => {
	const cartModal = {
		...useModal()
	};

	return {
		cartModal
	};
});
